import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';
import { LOCALE_CLICK, LOCALE_COMPLETE } from 'components/analytics/conversions/constants/actions';
import {
  sendTrackingEvent,
  trackCompleteEvent,
  findCategoryByElement,
  processLocale,
} from 'components/analytics/conversions/tracking';

export default class LanguageSwitcherController extends Controller {
  static targets = ['source'];

  intentionalLocaleCookieKey = 'intentional_locale_switch';

  handleLangSwitch = (event) => {
    event.preventDefault();
    this.requestLocaleDomainCookie(event);
  }

  requestLocaleDomainCookie = (event) => {
    const intentionalLocales = Cookies.getJSON(this.intentionalLocaleCookieKey);
    const { locale } = event.target.dataset;

    const locales = intentionalLocales ? intentionalLocales.filter((f) => f !== locale).concat(locale) : [locale];
    this.saveLocaleCookie(locales);

    const category = findCategoryByElement(event.target);
    const label = processLocale(locale);

    sendTrackingEvent({
      element: event.target,
      data: {
        action: LOCALE_CLICK,
        category,
        label,
      },
    });

    trackCompleteEvent({
      action: LOCALE_COMPLETE,
      category,
      label,
    });

    window.location.assign(event.target.href);
  }

  toggle(event) {
    event.preventDefault();

    this.sourceTarget.classList.toggle('is-visible');
    this.element.classList.toggle('menu-visible');
  }

  getCookieDomain() {
    const cookieDomainArray = window.location.hostname.split('.');
    return `${cookieDomainArray[1]}.${cookieDomainArray[2]}`;
  }

  saveLocaleCookie(locales) {
    Cookies.set(this.intentionalLocaleCookieKey, locales, { domain: this.getCookieDomain() });
  }
}
